import { FormHelperText } from 'opensolar-ui'
import { FC, ReactNode } from 'react'
import { Typography } from '../core/Typography'
import { styled } from '../styles'
import { ResetToDefaultButton, type ResetToDefaultButtonProps } from './ResetToDefaultButton'

export type { ResetToDefaultButtonProps }

interface PropTypes {
  required?: boolean
  label?: ReactNode
  labelAdornment?: string
  resetToDefault?: ResetToDefaultButtonProps
  error?: boolean
  isActiveOrFocus?: boolean
}

const LabelRoot = styled('span')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  maxWidth: '100%',
  minWidth: 0,
})

const StyledLabel = styled(Typography)<PropTypes>(({ error, isActiveOrFocus, theme }) => ({
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: error
    ? `${theme.palette.red[800]}`
    : isActiveOrFocus
      ? `${theme.palette.blue[800]}`
      : `${theme.palette.neutralGrey[1300]}`,
}))

export enum OsFieldTitleVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export const FieldTitle: FC<PropTypes> = ({
  label,
  required,
  labelAdornment,
  resetToDefault,
  error,
  isActiveOrFocus,
}) => {
  return (
    <LabelRoot>
      <StyledLabel variant="body2" error={error} isActiveOrFocus={isActiveOrFocus} component="span">
        {label}
        {required && ' *'}
      </StyledLabel>
      {resetToDefault ? <ResetToDefaultButton {...resetToDefault} /> : null}
      {labelAdornment && <FormHelperText>{labelAdornment}</FormHelperText>}
    </LabelRoot>
  )
}

export default FieldTitle
